import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'twoDigitFormat',
  pure: true
})
export class TwoDigitFormatPipe implements PipeTransform {
  transform(value: number | null): string {
    return String(value ?? '').padStart(2, '0');
  }
}